import { Modal, Button } from 'antd'
import { ExclamationCircleFilled, InfoCircleFilled } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

interface NoticeDialogProps {
  open: boolean
  title?: string
  message: string
  confirmLabel?: string
  variant?: 'warning' | 'info'
  onClose: () => void
}

const VARIANT_STYLES = {
  warning: {
    icon: <ExclamationCircleFilled style={{ color: '#f59e0b' }} />,
    bg: 'bg-amber-50',
    border: 'border-amber-200',
  },
  info: {
    icon: <InfoCircleFilled style={{ color: '#3b82f6' }} />,
    bg: 'bg-blue-50',
    border: 'border-blue-200',
  },
}

export default function NoticeDialog({
  open,
  title,
  message,
  confirmLabel,
  variant = 'warning',
  onClose,
}: NoticeDialogProps) {
  const { t } = useTranslation()
  const resolvedTitle = title ?? t('confirm')
  const resolvedConfirm = confirmLabel ?? t('confirm')
  const styles = VARIANT_STYLES[variant]

  return (
    <Modal
      open={open}
      title={
        <div className="flex items-center gap-2 text-base font-semibold text-gray-800">
          <span className="text-xl leading-none">{styles.icon}</span>
          <span>{resolvedTitle}</span>
        </div>
      }
      onCancel={onClose}
      footer={
        <div className="flex justify-end">
          <Button type="primary" onClick={onClose}>
            {resolvedConfirm}
          </Button>
        </div>
      }
      destroyOnHidden
      mask={{ closable: false }}
      width={460}
    >
      <div className={`mt-2 rounded-lg border ${styles.border} ${styles.bg} px-4 py-3`}>
        <p className="text-sm text-gray-800 whitespace-pre-wrap leading-relaxed">{message}</p>
      </div>
    </Modal>
  )
}
